import { Routes } from '@angular/router';
import { KontaktComponent } from "@core/views/kontakt/kontakt.component";
import { PasswortAendernComponent } from "@core/views/passwort-aendern/passwort-aendern.component";
import { PasswortVergessenComponent } from "@core/views/passwort-vergessen/passwort-vergessen.component";
import { TeilnehmerVerwaltenComponent } from "@core/views/teilnehmer-verwalten/teilnehmer-verwalten.component";
import { KursDetailsComponent } from "@core/views/kurs-details/kurs-details.component";
import { KurslisteComponent } from "@core/views/kursliste/kursliste.component";
import { WiderrufComponent } from "@core/views/widerruf/widerruf.component";
import { ZertifizierungsverlaufComponent } from "@core/views/zertifizierungsverlauf/zertifizierungsverlauf.component";
import { AuthGuardService } from "@core/services/auth-guard/auth-guard.service";
import { FaqComponent } from "@core/views/faq/faq.component";
import { FileDownloadComponent } from "@core/views/file-download/file-download.component";
import { SearchResultsComponent } from "@core/views/search-results/search-results.component";
import { SeiteComponent } from "@core/views/seite/seite.component";

export const APP_ROUTES: Routes = [
    {
        path: 'meinedaten',
        component: TeilnehmerVerwaltenComponent
    },
    {
        path: 'event/:id',
        component: KursDetailsComponent,
        data: {
            title: "Termine"
        }
    },
    {
        path: 'events',
        component: KurslisteComponent,
        data: {
            title: "Anmeldung / Termine"
        }
    },
    {
        path: 'passwort-aendern',
        component: PasswortAendernComponent,
        data: {
            title: "Passwort ändern"
        }
    },
    {
        path: 'passwortvergessen',
        component: PasswortVergessenComponent,
        data: {
            title: "Passwort vergessen"
        }
    },
    {
        path: 'zertifizierungsverlauf',
        component: ZertifizierungsverlaufComponent,
        data: {
            title: "Zertifizierungsverlauf"
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'search',
        component: SearchResultsComponent,
        data: {
            title: "Suche nach:"
        }
    },
    {
        path: 'file-download',
        component: FileDownloadComponent,
        data: {
            title: "File Download"
        }
    },
    {
        path: 'faq',
        component: FaqComponent,
        data: {
            title: "FAQ"
        }
    },
    {
        path: 'kontakt',
        component: KontaktComponent,
        data: {
            title: "Kontakt"
        }
    },
    {
        path: 'widerruf',
        component: WiderrufComponent,
        data: {
            title: "Widerruf"
        }
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        //muss als letztes stehen, da sonst alle Seiten hierher geleitet werden
        path: ':name',
        component: SeiteComponent
    }
];
